import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/action-required-list';
import mapByUserName from "../../import/normalize/map-user";
import SystemFieldUserViewInImport from "../../import/view-in-preview/user-view-in-preview";


export default class ActionRequiredField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.ACTION_REQUIRED;
    }

    get sortHintMessage() {
        return 'Sort by action required';
    }

    getCsvValue(item) {
        const user = gd.session.users.get(item.actionRequiredUserId);
        return user ? user.name : '';
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => (i.type === 'project' || !i.item.actionRequiredUserId) ? '-' : gd.session.users.get(i.item.actionRequiredUserId).name.toLowerCase()],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, 'gd-field-action-required', 'No action required');
    }

    // IMPORT

    normalizeCSVValue(value) {
        if (!value) return;
        return mapByUserName(gd.companyId, value);
    }

    getComponentViewInImport() {
        return SystemFieldUserViewInImport;
    }

}
